import ContextMenu from "./ContextMenu.vue";
import { pluginify } from "./../../util";
export default pluginify(ContextMenu);
export { ContextMenu };
